import { Role, RoutesMap } from 'ts/types/common'

export function filterRoutesByRole(routes: RoutesMap, userRole: Role): RoutesMap {
  const filteredRoutes: RoutesMap = {}

  Object.entries(routes).forEach(([key, route]) => {
    const hasPermission = !route.permissions || route.permissions.length === 0 || route.permissions.includes(userRole)

    if (hasPermission) {
      let filteredChildren: RoutesMap = {}

      if (route.children) {
        filteredChildren = filterRoutesByRole(route.children, userRole)
      }

      filteredRoutes[key] = {
        ...route,
        ...(filteredChildren ? { children: filteredChildren } : {})
      }
    }
  })

  return filteredRoutes
}
